import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/data-grid/column-menu/column-menu.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
